import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=bfb8d2ee&"
import script from "./StarRating.vue?vue&type=script&lang=ts&"
export * from "./StarRating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports